import { appData } from '@/mocks/home-data';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-600 rounded-xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
                {appData.desc}
              </p>
              <div className="grid grid-cols-2 gap-2 mb-6">
                {appData.features.map((feat) => (
                  <div key={feat} className="flex items-center gap-2 text-background-50/90">
                    <i className="ri-check-line text-accent-400 text-sm"></i>
                    <span className="text-xs md:text-sm">{feat}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-medium rounded-md text-sm cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors"
                >
                  <i className="ri-apple-line"></i>
                  App Store 下载
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/15 text-background-50 border border-background-50/30 font-medium rounded-md text-sm cursor-pointer whitespace-nowrap hover:bg-background-50/25 transition-colors"
                >
                  <i className="ri-android-line"></i>
                  安卓版下载
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 w-48 md:w-56">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20modern%20Chinese%20entertainment%20news%20app%20interface%20with%20warm%20red%20and%20gold%20accents%2C%20clean%20card%20layout%2C%20breaking%20news%20badges%2C%20minimalist%20UI%20design%2C%20isolated%20on%20transparent%20background%2C%20product%20photography%20style%2C%20soft%20lighting&width=480&height=960&seq=app-mockup-bagua&orientation=portrait"
                alt="爆料吃瓜 App 界面展示"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}